import { getUTCDate } from '@/shared/utils/date';
import FormattingTooltip from '@/components/basicComponents/tooltip/dollarsTooltip';
import { MobileRow, MobileRowTitle, MobileRowValue, MobileTableRowWrap } from '@/components/table/mobileTable/mobileTable';
import styled from 'styled-components';
import { TransformedAssetClassForecastValueDto } from '../../../../../types';

interface MobileTableProps {
  contributionsTableData: TransformedAssetClassForecastValueDto[];
  distributionsTableData: TransformedAssetClassForecastValueDto[];
}

interface AllocationSummary {
  [year: string]: number;
}

const MobileSumFooter = ({ contributionsTableData, distributionsTableData }: MobileTableProps) => {
  const dateContributionsSummary: AllocationSummary = {};
  const dateDistributionsSummary: AllocationSummary = {};

  const addValueToSummary = (summary: AllocationSummary, date: string, allocation: number) => {
    const year = getUTCDate(new Date(date)).toUpperCase();

    if (!summary[year]) {
      summary[year] = 0;
    }
    summary[year] += allocation;
  };

  contributionsTableData.forEach((assetClass) => {
    assetClass.values.forEach((allocation) => {
      addValueToSummary(dateContributionsSummary, allocation.date, allocation.value);
    });
  });

  distributionsTableData.forEach((assetClass) => {
    assetClass.values.forEach((allocation) => {
      addValueToSummary(dateDistributionsSummary, allocation.date, allocation.value);
    });
  });

  const calculateNetCashFlow = (contributions: AllocationSummary, distributions: AllocationSummary): AllocationSummary => {
    const result: AllocationSummary = {};
    for (const year in contributions) {
      if (contributions.hasOwnProperty(year) || distributions.hasOwnProperty(year)) {
        result[year] = (contributions[year] || 0) - (distributions[year] || 0);
      }
    }
    return result;
  };

  const netCashFlow = calculateNetCashFlow(dateContributionsSummary, dateDistributionsSummary);

  return (
    <MobileSumFooterWrap>
      <MobileRow>
        <MobileRowTitle>Net Cash Flow</MobileRowTitle>
      </MobileRow>

      {Object.entries(netCashFlow).map(([year, value]) => (
        <MobileRow key={year}>
          <MobileRowTitle>{year}</MobileRowTitle>
          <MobileRowValue>
            <FormattingTooltip zIndex={1000}>{value}</FormattingTooltip>
          </MobileRowValue>
        </MobileRow>
      ))}
    </MobileSumFooterWrap>
  );
};

const MobileSumFooterWrap = styled(MobileTableRowWrap)`
  background-color: ${({ theme }) => theme.layer[2]};
`;

export default MobileSumFooter;
